export const getServiceCategoryId = (service) =>
  service?.categoryId ??
  service?.SubCategory?.categoryId ??
  service?.subCategory?.categoryId ??
  null;

export const calculateReservationDuration = (services = []) => {
  const normalizedServices = services.filter(Boolean);
  if (!normalizedServices.length) {
    return 0;
  }

  const durations = normalizedServices.map((service) => Number(service.duration || 0));
  const categoryIds = [
    ...new Set(
      normalizedServices
        .map((service) => getServiceCategoryId(service))
        .filter((categoryId) => categoryId !== null && categoryId !== undefined)
    ),
  ];

  if (categoryIds.length <= 1) {
    return durations.reduce((sum, duration) => sum + duration, 0);
  }

  return durations.reduce((maxDuration, duration) => Math.max(maxDuration, duration), 0);
};

export const calculateCombinedReservationDuration = (
  services = [],
  selections = []
) => {
  const servicesById = new Map(
    services.filter(Boolean).map((service) => [Number(service.id), service])
  );

  const durationsByEmployee = selections.reduce((acc, selection) => {
    const employeeKey = Number(selection.employeeId);
    const service = servicesById.get(Number(selection.serviceId));

    if (!employeeKey || !service) {
      return acc;
    }

    const currentServices = acc.get(employeeKey) || [];
    currentServices.push(service);
    acc.set(employeeKey, currentServices);
    return acc;
  }, new Map());

  if (!durationsByEmployee.size) {
    return calculateReservationDuration(services);
  }

  return Math.max(
    ...Array.from(durationsByEmployee.values()).map((employeeServices) =>
      calculateReservationDuration(employeeServices)
    )
  );
};
